<template>
  <div class="cards__container">
    <div class="cards__single green">
      <p class="cards__title">
        Closing Pool Party Brought by Chardan
      </p>
      <div class="cards__description">
        <p>2:00 PM - 5:00 PM</p>
      </div>
      <div class="cards__location">
        @ Tacos & Tequila (Condado Vanderbilt)
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Day Three Afternoon',
  data() {
    return {
      activeCardInfo: null,
      isModalOpen: false,
      errorMessage: null,
      isMobile: false,
    }
  },
  mounted() {
    this.isMobile = window.innerWidth < 768;
    window.addEventListener('resize', this.handleResize);
  },
  methods: {
    handleResize() {
      this.isMobile = window.innerWidth < 768;
    },
    openModal(identifier) {
      if (this.cardData[identifier]) {
        this.activeCardInfo = this.cardData[identifier];
        this.activeCompanyInfo = null;
        this.errorMessage = null;
        this.isModalOpen = true;
      } else if (this.companyData[identifier]) {
        this.activeCompanyInfo = {
          ...this.companyData[identifier],
          company: identifier,
        };
        this.activeCardInfo = null;
        this.errorMessage = null;
        this.isModalOpen = true;
      } else {
        console.error(`Currently no info has been found for "${identifier}".`);
        this.activeCardInfo = null;
        this.activeCompanyInfo = null;
        this.errorMessage = null;
        this.isModalOpen = false;
      }
    },
    closeModal() {
      this.isModalOpen = false;
      this.activeCardInfo = null;
      this.activeCompanyInfo = null;
      this.errorMessage = null;
    },
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.handleResize);
  },
};

</script>